import React, { useEffect, useState } from 'react'
import { Container, Row, Table, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ABSpinner, InfoIcon, useErrorService } from '@abroad/components'
import API from '../../utils/API'
import { convertSessionDate } from '../../utils/date'
const placement = 'top'

const CoachingPlanPayment = ({ sowId }) => {
  const [paymentData, setPaymentData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const Error = useErrorService()

  useEffect(() => {
    const fetchCoachingPlanPayment = async () => {
      if (!sowId) {
        setIsLoading(false)
        return
      }

      try {
        setIsLoading(true)

        const { data } = await API.AdminAPI.coachPlan.getcoachingPlanPayment(
          sowId,
        )

        setPaymentData(data)
      } catch (err) {
        Error.showError(err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchCoachingPlanPayment()
  }, [sowId])

  const renderInfoIcon = (reason) => {
    return (
      <div className='d-flex'>
        <OverlayTrigger
          key={placement}
          placement={placement}
          overlay={
            <Tooltip
              style={{
                '--bs-tooltip-max-width': '22rem',
                maxWidth: '22rem',
              }}
              id={`tooltip-${placement}`}
              className='font-open-sans font-16 font-semibold leading-7 text-center payment-failed-info'>
              <div
                style={{
                  width: '100%',
                  maxWidth: '100%',
                  // minWidth: '15rem',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                }}>
                {reason}
              </div>
            </Tooltip>
          }>
          <span className='d-flex align-items-center justify-content-center ml-2 ms-2'>
            <InfoIcon className='cursor-pointer' />
          </span>
        </OverlayTrigger>
      </div>
    )
  }

  // Show loading spinner
  if (isLoading) {
    return <ABSpinner />
  }

  const payments = paymentData?.paymentHistory || []

  return (
    <div className='coaching-plan-payments'>
      {!isLoading && (
        <Container className='px-0' fluid>
          <Row className='m-0 d-lg-block'>
            <div className='col-xs-12'>
              <div>
                <Table hover responsive className='custom-table'>
                  <thead>
                    <tr>
                      <th width='15%'>DATE</th>
                      <th width='15%'>AMOUNT</th>
                      <th width='15%'>STATUS</th>
                      <th width='15%'>NEXT PAYMENT DATE</th>
                      <th width='15%'>PAYMENT LEFT</th>
                      <th width='20%'>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payments?.length > 0 ? (
                      payments.map((payment, index) => (
                        <tr key={payment._id || index}>
                          <td>
                            {convertSessionDate(payment.date, 'MM/DD/YYYY')}
                          </td>
                          <td>
                            <span>${payment.amount}</span>
                          </td>
                          <td>
                            {payment.paid ? (
                              'Success'
                            ) : (
                              <div className='d-flex'>
                                Failed {renderInfoIcon(payment?.reason)}
                              </div>
                            )}
                          </td>
                          <td>
                            {convertSessionDate(
                              payment.nextPaymentDate,
                              'MM/DD/YYYY',
                            ) || '-'}
                          </td>
                          <td>${payment.paymentLeft || 0}</td>
                          <td>
                            {payment.paid === true ? (
                              <a
                                className='text-warning text-decoration-none cursor-pointer'
                                href={payment?.receiptUrl}
                                download // This prompts the download
                              >
                                Print Invoice
                              </a>
                            ) : (
                              <span className='text-muted'>-</span>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan='6' className='text-center font-montserrat'>
                          No Payment History Found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </Row>
        </Container>
      )}
    </div>
  )
}

export default CoachingPlanPayment
